import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  SimpleGrid,
  Card,
} from '@chakra-ui/react';

function LandingPage() {
  return (
    <Box>
      {/* Hero Section */}
      <Container maxW="container.xl" py={20}>
        <VStack gap={6} textAlign="center">
          <Heading size="4xl" fontWeight="bold">
            Get Your WordPress Website
            <br />
            <Text as="span" color="brand.500">
              Quote in Minutes
            </Text>
          </Heading>

          <Text fontSize="xl" color="gray.600" maxW="2xl">
            Our AI-powered system analyzes your requirements and generates
            accurate, transparent quotes instantly. No hidden costs, no waiting.
          </Text>

          <HStack gap={4} pt={4}>
            <Button asChild size="lg" colorPalette="brand">
              <RouterLink to="/quote/new">Start Free Quote</RouterLink>
            </Button>
            <Button asChild size="lg" variant="outline">
              <RouterLink to="/sign-in">View Demo</RouterLink>
            </Button>
          </HStack>
        </VStack>
      </Container>

      {/* Features Section */}
      <Box bg="gray.50" py={20}>
        <Container maxW="container.xl">
          <VStack gap={12}>
            <VStack gap={4} textAlign="center">
              <Heading size="2xl">How It Works</Heading>
              <Text fontSize="lg" color="gray.600">
                Three simple steps to get your custom quote
              </Text>
            </VStack>

            <SimpleGrid columns={{ base: 1, md: 3 }} gap={8}>
              <Card.Root>
                <Card.Body>
                  <VStack gap={4} align="start">
                    <Box
                      w={12}
                      h={12}
                      bg="brand.100"
                      rounded="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text fontSize="xl" fontWeight="bold" color="brand.600">
                        1
                      </Text>
                    </Box>
                    <Heading size="lg">Chat with AI</Heading>
                    <Text color="gray.600">
                      Tell us about your project through a simple conversation.
                      Upload examples, share links, or describe your vision.
                    </Text>
                  </VStack>
                </Card.Body>
              </Card.Root>

              <Card.Root>
                <Card.Body>
                  <VStack gap={4} align="start">
                    <Box
                      w={12}
                      h={12}
                      bg="brand.100"
                      rounded="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text fontSize="xl" fontWeight="bold" color="brand.600">
                        2
                      </Text>
                    </Box>
                    <Heading size="lg">Get Analysis</Heading>
                    <Text color="gray.600">
                      Our AI analyzes your requirements, competitors, and
                      industry standards to create a comprehensive plan.
                    </Text>
                  </VStack>
                </Card.Body>
              </Card.Root>

              <Card.Root>
                <Card.Body>
                  <VStack gap={4} align="start">
                    <Box
                      w={12}
                      h={12}
                      bg="brand.100"
                      rounded="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text fontSize="xl" fontWeight="bold" color="brand.600">
                        3
                      </Text>
                    </Box>
                    <Heading size="lg">Receive Quote</Heading>
                    <Text color="gray.600">
                      Get a detailed, itemized quote with timeline, costs, and
                      optional features. Accept, modify, or discuss further.
                    </Text>
                  </VStack>
                </Card.Body>
              </Card.Root>
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* CTA Section */}
      <Container maxW="container.xl" py={20}>
        <VStack gap={6} textAlign="center">
          <Heading size="2xl">Ready to Get Started?</Heading>
          <Text fontSize="lg" color="gray.600">
            Join hundreds of businesses who've streamlined their web development process
          </Text>
          <Button asChild size="lg" colorPalette="brand">
            <RouterLink to="/sign-up">Create Free Account</RouterLink>
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}

export default LandingPage;